import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(_Circle, { cx: "11.5", cy: "12.5", r: "2.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M13.27 14.27 15 16", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FolderSearch2";
const FolderSearch2 = memo(themed(Icon));
export {
  FolderSearch2
};
//# sourceMappingURL=folder-search-2.js.map
